
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputDown as ObiInputDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-down.js';
 
 
 

 
 export const ObiInputDown = createComponent({
   react: React,
   tagName: 'obi-input-down',
   elementClass: ObiInputDownElement,
   events: {
     
   }
  });
 
 